import { Dispatch } from 'redux'
import { PartnerOrgStatisticsActionType } from '../action-types'
import config from '../../config'
import axios from 'axios'

const { apiUrl } = config

export const getPartnerOrgStatistics =
    (partnerId: number, organizationId: number, year: string) =>
    async (dispatch: Dispatch) => {
        dispatch({
            type: PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_REQUEST,
        })
        try {
            const res = await axios.get(
                `${apiUrl}/v1/partners/${partnerId}/organizations/${organizationId}/complete-statistics?year=${year}`
            )
            dispatch({
                type: PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_SUCCESS,
                payload: res.data.data,
            })
        } catch (error) {
            dispatch({
                type: PartnerOrgStatisticsActionType.PARTNER_ORG_STATISTICS_ERROR,
                payload: 'Error loading statistics',
            })
        }
    }
